<template>
	<div id="victory">
		<div>Victory!</div>
	</div>
</template>

<script lang="ts">
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {
	name: 'Victory',
	components: {},
	data() {
		return {}
	},
	props: {},
	computed: {
		// ...mapGetters('ui', ),
	},
	methods: {
		// ...mapMutations('ui', ),
		// ...mapActions('ui', ),
	},
}
</script>

<style lang="less" scoped>
@import url('../../web/global/fonts/fonts.less');

#victory {
	position: fixed;
	width: 100vw;
	height: 100vh;
	left: 0;
	top: 0;

	animation: fadeToWhite linear 4s;

	background-color: rgba(255, 255, 255, 0.5);

	div {
		position: absolute;
		left: 0;
		top: 20%;
		width: 100vw;

		text-align: center;

		color: @blueishThree;
		font-variant: small-caps;
		font-size: 120px;

		.regularFont(@enRegularFontPixl);
	}
}

@keyframes fadeToWhite {
	0% {
		background-color: rgba(255, 255, 255, 0);
	}
	100% {
		background-color: rgba(255, 255, 255, 0.5);
	}
}
</style>
